import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Container,
    Typography,
    TextField,
    Table, TableBody, TableRow, TableCell, MenuItem,
} from '@mui/material';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    Black,
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell
} from "../../../styles/MyStyles";
import {GetAssetLookupMenuItemsByType} from "../../../logic/LookupHelper";
import {GetAccountOwnerItems} from "../../../logic/AccountOwnerHelper";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetClients} from "../../../logic/DataProvider";

const WalletEditPage = () => {
    const { clientId, walletId} = useParams();
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    const [wallet, setWallet] = useState({
        assetId: '',
        ownerId: clientId ? '' : Number(process.env.REACT_APP_NEWCENT_CONTACT_ID),
        forClientId: clientId ? clientId : '',
        address: '',
        isMultisig: false
    });

    const [clients, setClients] = useState([]);

    useEffect(() => {
        console.log('clientId=' + clientId)
        if (!clientId) {
            GetClients().then((clients) => setClients(clients));
        }
        const fetchWallet = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                if (walletId) {
                    const response = await fetch(
                        `${process.env.REACT_APP_WALLETS_URL}/single/${walletId}`,
                        {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + tokenCookie.value,
                            },
                        }
                    );
                    if (response.ok) {
                        const data = await response.json();
                        if (data.data.forClientId === null) {
                            data.data.forClientId = '';
                        }
                        setWallet(data.data);
                    } else {
                        console.log('Fetch wallet failed.');
                    }
                } else {
                    setWallet({
                        assetId: '',
                        ownerId: clientId ? '' : Number(process.env.REACT_APP_NEWCENT_CONTACT_ID),
                        forClientId: clientId ? clientId : '',
                        address: '',
                        isMultisig: false
                    });
                    console.log(wallet);
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };

        fetchWallet();
    }, [walletId]);

    const validateForm = () => {
        let newErrors = {};

        if (wallet.assetId === '') {
            newErrors.assetId = 'Asset is required.';
        }

        if (wallet.ownerId === '') {
            newErrors.ownerId = 'Owner is required.';
        }

        if (!wallet.address.trim()) {
            newErrors.address = 'Address is required.';
        }

        // Return the errors
        return newErrors;
    };

    const handleFieldChange = (event) => {
        setWallet({
            ...wallet,
            [event.target.name]: event.target.value,
        });

        //setErrors(validateForm());
    };

    const handleSave = async () => {
        try {
            const newErrors = validateForm();

            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                return;
            }

            if (!wallet.forClientId) {
                wallet.forClientId = null;
            }

            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(
                `${process.env.REACT_APP_WALLETS_URL}`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(wallet),
                }
            );
            if (response.ok) {
                console.log('Wallet updated successfully.');
                handleGoBack();
            } else {
                console.log('Update wallet failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };

    const handleGoBack = () => {
        navigate(-1);
    };

    const getClientsMenuItems = () => {
        let items = [<MenuItem key="" value="">Not assigned</MenuItem>];
        if (clients) {
            clients.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetClientViewName(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Typography variant="h4" gutterBottom sx={{ color: Black }}>
                {walletId ? 'Edit Wallet' : 'Create Wallet'}
            </Typography>
            <StyledButtonContainer container>
                <StyledButtonOrange variant="contained" onClick={handleGoBack}>
                    Back
                </StyledButtonOrange>
                <StyledButtonOrange variant="contained" onClick={handleSave}>
                    Save
                </StyledButtonOrange>
            </StyledButtonContainer>
            <Table>
                <TableBody>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Asset</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="assetId"
                                label="Asset"
                                select
                                value={wallet.assetId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.assetId}
                                helperText={errors.assetId}
                            >
                                {GetAssetLookupMenuItemsByType(1)}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Owner</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="ownerId"
                                label="Owner"
                                select
                                value={wallet.ownerId}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                disabled={clientId === ''}
                                error={!!errors.ownerId}
                                helperText={errors.ownerId}
                            >
                                {GetAccountOwnerItems(clientId)}
                            </TextField>
                        </TableCell>
                    </TableRow>
                    {!clientId && (
                        <TableRow>
                            <StyledTableCell style={{ width: '10%' }}>For Client</StyledTableCell>
                            <TableCell style={{ width: '90%' }}>
                                <TextField
                                    name="forClientId"
                                    label="For Client"
                                    select
                                    value={wallet.forClientId}
                                    onChange={handleFieldChange}
                                    fullWidth
                                >
                                    {getClientsMenuItems()}
                                </TextField>
                            </TableCell>
                        </TableRow>
                    )}
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Address</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="address"
                                label="Address"
                                value={wallet.address}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                                error={!!errors.address}
                                helperText={errors.address}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <StyledTableCell style={{ width: '10%' }}>Multisig</StyledTableCell>
                        <TableCell style={{ width: '90%' }}>
                            <TextField
                                name="isMultisig"
                                label="Multisig"
                                select
                                value={wallet.isMultisig}
                                onChange={handleFieldChange}
                                fullWidth
                                required
                            >
                                <MenuItem value={false}>No</MenuItem>
                                <MenuItem value={true}>Yes</MenuItem>
                            </TextField>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Container>
    );
};

export default WalletEditPage;
